import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Filter from "../components/datatable/Filter";
import Button from "../components/Button";

const FILTER_OPTIONS = {
    all: {
        name:   'All',
        value:  'all',
    },
    scheduled: {
        name:   'Scheduled',
        value:  'scheduled',
    },
    in_progress: {
        name:   'In Progress',
        value:  'in_progress',
    },
    completed: {
        name:   'Completed',
        value:  'completed',
    },
    archived: {
        name:   'Archived',
        value:  'archived',
    },
}

const OverviewInstallationDataTable = (props) => {
    const dataTableRef                      = useRef(null);
    const [search, setSearch]               = useState("");
    const [statusFilter, setFilter]         = useState(FILTER_OPTIONS.all.value);
    const [jobTypeFilter, setJobTypeFilter] = useState(null);
    const [userFilter, setUserFilter]       = useState(null);

    const renderRowButton = (installation) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!installation.can && installation.can.view === true && installation.deleted_at === "-" && (
                        <a className="text-primary cursor-pointer" href={route('job.order.installation.show', {job: installation.job_id, order: installation.order_id, installation: installation.id}).toString()}>
                            View
                        </a>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card classes={"border-0"} noPadding={true}>
                <div className="row">
                    <div className="col-12 col-xl-3 mb-3">
                        <SearchInput
                            value={search}
                            classes={""}
                            placeholder={"Search..."}
                            onChange={(value) => setSearch(value)}
                        />
                    </div>
                    <Filter
                        label={"Status:"}
                        value={statusFilter}
                        options={Object.values(FILTER_OPTIONS)}
                        name={"filter_status"}
                        onChange={(value) => setFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <Filter
                        label={"Job Type:"}
                        value={jobTypeFilter}
                        options={props.jobTypes}
                        name={"filter_job_type"}
                        onChange={(value) => setJobTypeFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <Filter
                        label={"User:"}
                        value={userFilter}
                        options={props.users}
                        name={"filter_user"}
                        onChange={(value) => setUserFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <div className="col-1"></div>
                    {can('create', 'job') && (
                        <div className="col-2 col-xs-4 float-right mb-3">
                            <Button
                                href={route('job.create', {origin: "overview-installation"}).toString()}
                                label={"Create Job"}
                                icon={"far fa-plus-circle"}
                                classes={"btn btn-eh-lilac px-3 justify-content-center"}
                            />
                        </div>
                    )}
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.overview.installation.data-table').toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="installations" />}
                                fieldsToExclude={statusFilter === FILTER_OPTIONS.archived.value ? [
                                    'job_id',
                                    'created_at',
                                    'can',
                                ] : [
                                    'job_id',
                                    'created_at',
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldOrder={[
                                    "id",
                                    "order_id",
                                    "job_name",
                                    "job_type",
                                    "customer_name",
                                    'start_at',
                                    'end_at',
                                    'users',
                                    "status",
                                    "deleted_at"
                                ]}
                                fieldMap={{
                                    id:             "Installation Ref",
                                    order_id:       "Order Ref",
                                    job_name:       "Job Name",
                                    job_type:       "Type",
                                    customer_name:  "Customer",
                                    start_at:       "Start Date",
                                    end_at:         "End Date",
                                    status:         "Status",
                                    deleted_at:     "Date Archived",
                                    users:          "Installer",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'start_at'}
                                defaultOrderByDirection={'asc'}
                                params={{
                                    searchTerm:    search,
                                    statusFilter:  statusFilter,
                                    jobTypeFilter: jobTypeFilter,
                                    userFilter:    userFilter,
                                }}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'status':
                                            return (
                                                <span className={"text-eh-light-blue font-weight-bold"}>{value}</span>
                                            );
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment>
    );
}

export default OverviewInstallationDataTable;

const target = document.getElementById('overview-installation-datatable');
if (target) {
    ReactDOM.render(
        <OverviewInstallationDataTable
            jobTypes={JSON.parse(target.dataset.jobTypes)}
            users={JSON.parse(target.dataset.users)}
        />,
        target
    );
}
